export const SUBMIT_CONTACT_INFO = 'App/Recap::SUBMIT_CONTACT_INFO';
